module.exports = __webpack_public_path__ + "static/media/users.f3e1f375.svg";